import { render, staticRenderFns } from "./SystemInfoGameServer.vue?vue&type=template&id=46577914&scoped=true&"
import script from "./SystemInfoGameServer.vue?vue&type=script&lang=js&"
export * from "./SystemInfoGameServer.vue?vue&type=script&lang=js&"
import style0 from "./SystemInfoGameServer.vue?vue&type=style&index=0&id=46577914&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46577914",
  null
  
)

export default component.exports